import { SET_FILTERS } from "./types";

const getInitialState = () => {
  const found = initialState.find(item => {
    return item.ui;
  });
  return found ? found.ui.theBeersPage : {};
};

export default (state = getInitialState(), action) => {
  switch (action.type) {
    case SET_FILTERS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/services/filters/reducer.js